import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CatalogResponse } from '../../api/models/CatalogResponse';
import { FileUploadPlacardConfirmationRequest } from '../../api/models/FileUploadPlacardConfirmationRequest';
import { UploadedImageInformation } from '../../api/models/placardConfirmationSession';
import { PlacardLocationSession } from '../../api/models/PlacardLocationSession';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, ConfirmationFlowConstants, RouteURLConstants, ServiceURLConstants } from '../../constants/upplm.constants';
import { CATALOG, PICKUP_LOCATION, PLACARD_LOCATION } from '../../constants/upplm.constants.placardlocation';
import { FileUploadPlacardConfirmationResponse } from '../../interface/upplm.fileuploadplacardconfirmation';
import { Catalog } from '../../interface/upplm.placardconfirmation';
import { PlacardLocationStatusResponse } from '../../interface/upplm.placardLocation';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';
const METAL_BOX_KEY = 'Metal Box';

@Component({
    selector: 'placardlocation',
    template: require('./placardLocation.component.html')
})
/** placardLocation component*/
export class PlacardLocationComponent implements OnInit, OnDestroy {
    @ViewChild('sessionnTimeOut', { static: false }) sessionnTimeOut: UpsDialogComponent;
    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    public messagesErrorServer: string = '';
    public sessionnTimeOutTitle: string ='';
    public isInitialLoading: boolean = true;
    catalogResponse: CatalogResponse;
    sessionData: SessionResponse;
    public isLoadding: boolean = false;
    public comesFromReview: boolean = false;
    paramsUrl: string = '?loc=en_US&placardid=';
    paramsUrlCatalog: string = '/PICKUP_LOCATION/PLACARD_LOCATION';
    private fileUploadRequest: FileUploadPlacardConfirmationRequest = new FileUploadPlacardConfirmationRequest();
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    badRequest: boolean;
    errorMessageBadRequest: string = '';
    placardlocationsCopy: any;
    placardlocations: any;
    pickuplocations: any;
    InputAditionalLocDet: string;
    InputLockCombination: string;
    InputAditionalLocDet26: string;
    metalBoxOption: boolean;
    placardLoc: string = "";
    pickuploc: string = "";
    placardSelected: string = "";
    editplacardReturn: string = "";
    pickupSelected: string = "";
    errorPlacardSelected: boolean;
    errorPickupSelected: boolean;
    validateFirstTime: boolean;
    validateFirstTime26: boolean;
    validateFirstTimeLockCombination: boolean;
    lockCombinationValue: string;
    placardLocationDropDown: string;
    pickupLocationDropDown: string;
    placardSelected26: string;
    errorValidation: boolean;
    formData: FormData = new FormData();
    filesUpload: Array<any> = [];
    lockTemp: string = '';
    editReturn: boolean = false;
    subscription: Subscription;

    messageErrorPickup: boolean;
    messageErrorPlacard: boolean;
    messageErrorAdditional40: boolean;
    messageErrorAdditional26: boolean;
    messageErrorLockCombination: boolean;

    @ViewChild("additionalLocationDetailsInput", { static: false }) additionalLocationDetailsInput: ElementRef;

    //Model
    placardLocation: string;
    metalBoxInd: boolean;
    pickupLocation: string;
    additionalLocationDetails: string;
    lockCombination: string;

    //--------------------------------------------------
    //Variables for Page Title and Header
    //--------------------------------------------------
    pageTitleText = '';
    ManageUPSText = '';
    public breadCrumbItems: BreadcrumbItem[] = [];

    constructor(private router: Router,
        private location: Location,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _pbService: ProgressBarService,
        private _translateData: TranslateDataPipe) {
        this.metalBoxOption = false;
        this.cleanFiels();
    }


    ngOnInit() {
        this.sessionnTimeOutTitle = this._translateData.transform('upplm.common.sessiontimedouttitle');
        this.backBrowser();
        this.createBreadCrumb();
        this.pageTitleText = this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle');
        this.ManageUPSText = `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`;
        this.isInitialLoading = true;
        this.sessionData = this._sessionService.sessionData;
        let request = this.createSessionRequest(false);
        let requestImg: UploadedImageInformation = new UploadedImageInformation();
        if (request.placardConfirmation) {
            requestImg = request.placardConfirmation.placardImage;
            delete request.placardConfirmation.placardImage;
        }
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key) {
                if (response.placardConfirmation) {
                    response.placardConfirmation.placardImage = requestImg;
                }
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                this.comesFromReview = this.sessionData.comesFromReview;

                if (this.comesFromReview) {
                    this.getCatalog(true);
                } else {
                    this.getCatalog(false);
                }
                if (this.sessionData.placardConfirmation == null) {
                    this._commonService.url = RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE;
                }
                this.isInitialLoading = false;
            }
        });
    }

    ngAfterViewInit() {
        this.SessionErrorModal.setProperties({
            title: ConfirmationFlowConstants.SERVICE_ERROR
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public changeValueMetal() {
        var temp = '';
        if (this.metalBoxOption) {
            this.placardlocations = this.placardlocationsCopy.filter(x => x.key === METAL_BOX_KEY);
            if (this.InputAditionalLocDet.length > 25) {
                temp = this.InputAditionalLocDet.slice(0, 26);
            } else {
                temp = this.InputAditionalLocDet;
            }
        }
        else {
            temp = this.InputAditionalLocDet26;
            this.lockTemp = this.InputLockCombination;
            this.placardlocations = this.placardlocationsCopy.filter(x => x.key !== METAL_BOX_KEY);
            this.placardSelected = '';
        }
        this.cleanFiels();
        if (this.metalBoxOption == true) {
            this.InputAditionalLocDet26 = temp;
            this.InputLockCombination = this.lockTemp;
        } else {
            this.InputAditionalLocDet = temp;
        }
    }

    selectDropdDownPlacardLocation(optionSelectedPlacard) {
        this.placardLocationDropDown = optionSelectedPlacard;
        this.errorPlacardSelected = optionSelectedPlacard == "" ? true : false;
    }

    selectDropdDownPickupLocation(optionSelectedPickup) {
        this.pickupLocationDropDown = optionSelectedPickup;
        this.errorPickupSelected = optionSelectedPickup == "" ? true : false;
    }

    public validatorAdditionalLocDet() {
        this.validateFirstTime = false;
    }

    public validatorAdditionalLocDet26() {
        this.validateFirstTime26 = false;
    }

    public validatorLockCombination() {
        this.validateFirstTimeLockCombination = false;
    }

    public Submit() {
        this.isInitialLoading = true;
        if (this.metalBoxOption) {
            this.errorValidation = false;
            this.checkPickupLocation();
            if (this.InputLockCombination.length == 0) {
                this.validateFirstTimeLockCombination = false;
                this.messageErrorLockCombination = true;
                this.InputLockCombination = "";
                this.errorValidation = true;
            }
            if (this.InputAditionalLocDet26.length == 0) {
                this.validateFirstTime26 = false;
                this.messageErrorAdditional26 = true;
                this.InputAditionalLocDet26 = "";
                this.errorValidation = true;
            }
            this.setValuesOnValidation();
        }
        if (this.metalBoxOption == false) {
            this.errorValidation = false;
            this.checkPickupLocation();
            if ((this.errorPlacardSelected == true || this.errorPlacardSelected == null) && this.placardLocationDropDown == "" || this.placardLocationDropDown == undefined) {
                this.errorPlacardSelected = true;
                this.messageErrorPlacard = true;
                this.errorValidation = true;
            }
            if (this.InputAditionalLocDet.length == 0) {
                this.validateFirstTime = false;
                this.messageErrorAdditional40 = true;
                this.InputAditionalLocDet = "";
                this.errorValidation = true;
            }
            this.setValuesOnValidation();
        }
        this.isInitialLoading = false;
    }

    checkPickupLocation() {
        if ((this.errorPickupSelected || this.errorPickupSelected === null) && this.pickupLocationDropDown === "" || this.pickupLocationDropDown == undefined) {
            this.errorPickupSelected = true;
            this.messageErrorPickup = true;
            this.errorValidation = true;
        }
    }

    setValuesOnValidation() {
        if (this.errorValidation != true) {
            if (this.metalBoxOption) {
                this.placardLocation = "Metal Box";
                this.metalBoxInd = true;
                this.additionalLocationDetails = this.InputAditionalLocDet26;
                this.lockCombination = this.InputLockCombination;
            } else {
                this.placardLocation = this.placardSelected;
                this.metalBoxInd = false;
                this.additionalLocationDetails = this.InputAditionalLocDet;
                this.lockCombination = null;
            }
            this.pickupLocation = this.pickupSelected;
            this.fileUpload();
        }
    }

    cleanFiels() {
        this.errorPlacardSelected = null;
        this.errorPickupSelected = null;
        this.InputAditionalLocDet = "";
        this.InputLockCombination = "";
        this.InputAditionalLocDet26 = "";
        this.validateFirstTime = true;
        this.validateFirstTime26 = true;
        this.validateFirstTimeLockCombination = true;
        this.lockCombinationValue = null;
        this.messageErrorPickup = false;
        this.messageErrorPlacard = false;
        this.messageErrorAdditional40 = false;
        this.messageErrorAdditional26 = false;
        this.messageErrorLockCombination = false;
    }

    fileUpload() {

        if (!this._sessionService.isValidSession()) {
            this.openSessionTimeOutModel();
        }
        else {
            this.createRequest();
            if (!this.isLoadding) {
                this.isLoadding = true;
                if (this.sessionData.comesFromReview) {
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE + this.paramsUrl.concat(this.sessionData.placardID), true);
                }
                else {
                    let url = this._commonService.createURL(ServiceURLConstants.PLACARD_LOCATION_DETAILS_CONFIRMATION + this.sessionData.placardID, ApiErrorCode.CREATE_PLACARD_CONFIRMATION);
                    this._apiService.PostServiceAPI(url,
                        this.fileUploadRequest).
                        subscribe((response: FileUploadPlacardConfirmationResponse) => {
                            if (response.errors) {
                                this.sendBadRequest(response.errors);
                            } else {
                                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_CONFIRMED_ROUTE + this.paramsUrl.concat(response.placardId), true);
                            }
                        });
                }
            }
        }
    }

    createRequest() {

        this.fileUploadRequest = {
            placardImage: this.getPlacardImage(),
            placardLocation: this.placardLocation,
            metalBoxInd: this.metalBoxInd,
            additionalLocationDetails: this.additionalLocationDetails,
            pickupLocation: this.pickupLocation,
            lockCombination: this.lockCombination,
            placardDisplayed: true,
            pickupStartDate: this.sessionData.placardConfirmation.pickupStartDate
        }
    }

    getPlacardImage() {
        if (this.sessionData.placardConfirmation.placardImage === null || this.sessionData.placardConfirmation.placardImage === undefined) {
            return null;
        } else {
            var imageUpload = {
                name: this.sessionData.placardConfirmation.placardImage.name,
                contents: this.sessionData.placardConfirmation.placardImage.contents,
                extension: this.sessionData.placardConfirmation.placardImage.extension
            }
            return imageUpload;
        }
    }

    async sendBadRequest(error) {
        this.badRequest = true;
        this.isInitialLoading = false;
        this.errorMessageBadRequest = this._translateData.transform('upplm.common.serviceerror');
        await new Promise(resolve => setTimeout(resolve, 5000));
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.sessionData.placardConfirmation.placardId));
    }

    public save() {
        if (this.metalBoxOption === this.sessionData.placardLocation.metalBoxInd) {
            this.validationMetalBoxOption(this.sessionData.placardLocation.metalBoxInd);
        } else {
            this.validationMetalBoxOption(this.metalBoxOption);
        }
        this.Submit();
    }

    public cancel() {
        if (this.sessionData.comesFromReview) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE, false);
        }
        else {
            this.cancelGoDashboardPage();
        }
    }

    private validationMetalBoxOption(metalBoxOption: boolean): void {
        if (metalBoxOption) {
            this.placardLocation = METAL_BOX_KEY;
            this.metalBoxInd = true;
            this.pickupLocation = this.pickupSelected;
            this.additionalLocationDetails = this.InputAditionalLocDet26;
            this.lockCombination = this.InputLockCombination;
            this.pickupLocationDropDown = this.pickupLocationDropDown === undefined ? this.pickuplocations.filter(x => x.value === this.sessionData.placardLocation.pickupLocation)[0].key : this.pickupLocationDropDown;
        } else {

            this.placardLocation = this.placardSelected;
            this.metalBoxInd = false;
            this.pickupLocation = this.pickupSelected;
            this.additionalLocationDetails = this.InputAditionalLocDet;
            this.lockCombination = null;
            this.pickupLocationDropDown = this.pickupLocationDropDown === undefined ? this.pickuplocations.filter(x => x.value === this.sessionData.placardLocation.pickupLocation)[0].key : this.pickupLocationDropDown;
            this.placardLocationDropDown = this.placardLocationDropDown === undefined ?
                (this.placardLocation === '' ? '' : this.placardlocations.filter(x => x.value === this.sessionData.placardLocation.placardLocation)[0].key) :
                (this.placardLocation === '' ? '' : this.pickupLocationDropDown);
        }
    }

    getCatalog(sessionDataEdit: boolean) {
        let url = ServiceURLConstants.GET_CATALOG + this.paramsUrlCatalog;
        this._apiService.getCatalogData(this._commonService.createURL(url, ApiErrorCode.CREATE_PLACARD_CONFIRMATION)).toPromise()
            .then((response: PlacardLocationStatusResponse) => {
                if (response.errors !== null) {
                    if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                        this.messagesErrorServer = this._translateData.transform('upplm.common.serviceerror');
                        this.openModel();
                        return;
                    }
                }

                let catalogs: any = [];
                if (response.catalogs !== null) {
                    response.catalogs.forEach(element => {
                        catalogs.push(element);
                    });
                }
                let js = JSON.stringify(catalogs);
                let catalog = JSON.parse(js);

                let pickupLocationCatalog = catalog[0];
                let placardLocationCatalog = catalog[1];

                this.pickuplocations = this.getTranslatedLocations(pickupLocationCatalog.elements, CATALOG.PICKUP_LOCATION);
                this.placardlocationsCopy = this.getTranslatedLocations(placardLocationCatalog.elements, CATALOG.PLACARD_LOCATION);

                if (sessionDataEdit) {
                    if (this.sessionData.placardLocation.metalBoxInd) {
                        this.placardlocations = this.placardlocationsCopy.filter(x => x.key === METAL_BOX_KEY);
                    } else {
                        this.placardlocations = this.placardlocationsCopy.filter(x => x.key !== METAL_BOX_KEY);
                    }
                    this.fbindDataFromSession(this.sessionData.placardLocation);
                } else {
                    if (this.metalBoxOption) {
                        this.placardlocations = this.placardlocationsCopy.filter(x => x.key === METAL_BOX_KEY);;
                    } else {
                        this.placardlocations = this.placardlocationsCopy.filter(x => x.key !== METAL_BOX_KEY);
                    }
                }
            })
    }

    getTranslatedLocations(_catalogElements: any[], catalog: string): Catalog[] {
        let translatedCatalog: Catalog[] = [];
        _catalogElements.forEach(function (_element) {
            let location: Catalog = {
                key: _element.key,
                value: catalog === CATALOG.PLACARD_LOCATION ? this._translateData.transform(PLACARD_LOCATION.find(x => x.key === _element.key).value) :
                    this._translateData.transform(PICKUP_LOCATION.find(x => x.key === _element.key).value)
            };
            translatedCatalog.push(location);
        }, this);
        return translatedCatalog;
    }

    validateSessionAndNavigate(target: string, updateSession: boolean) {
        if (!this._sessionService.isValidSession()) {
            this.openSessionTimeOutModel();
        } else {
            let request = this.createSessionRequest(updateSession);
            let requestImg = request.placardConfirmation.placardImage;
            delete request.placardConfirmation.placardImage;
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    if (response.placardConfirmation != null) {

                        response.placardConfirmation.placardImage = requestImg;
                        this._sessionService.mapSessionResponse(response);
                        this._commonService.url = target;
                        this.router.navigateByUrl(target);
                    } else {
                        this.openModel();
                        this.isLoadding = false;
                    }
                }
            });
        }
    }

    fbindDataFromSession(data: PlacardLocationSession) {
        this.metalBoxOption = data.metalBoxInd;
        if (this.metalBoxOption) {
            this.InputLockCombination = data.lockCombination;
            this.pickupSelected = this.pickuplocations.filter(x => x.key === data.pickupLocationKey)[0].key;
            this.placardSelected = this.placardlocations[0].key;
            this.InputAditionalLocDet26 = data.additionalLocationDetails;
            this.editReturn = true;
            this.editplacardReturn = data.placardLocation;
            this.metalBoxOption = true;
        }
        else {

            this.pickupSelected = this.pickuplocations.filter(x => x.key === data.pickupLocationKey)[0].key;
            this.placardSelected = this.placardlocations.filter(x => x.key === data.placardLocationKey)[0].key;
            this.InputAditionalLocDet = data.additionalLocationDetails;
            this.metalBoxOption = false;
        }

    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.placardStatus = this.sessionData.placardStatus;
        request.comesFromReview = this.sessionData.comesFromReview;
        request.backBrowserPage = this.sessionData.backBrowserPage;
        request.locationDetails = this.sessionData.locationDetails;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        if (this.sessionData.placardConfirmation) {
            request.placardID = this.sessionData.placardConfirmation.placardId;
            request.placardConfirmation = this.sessionData.placardConfirmation;
            request.placardConfirmation.placardImage = this.sessionData.placardConfirmation.placardImage;
        }
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.createPickUp = this.sessionData.createPickUp;
        request.lastTimeSessionReqired = new Date().toString();
        if (update) {
            let data: PlacardLocationSession = new PlacardLocationSession();
            data.pickupLocationKey = this.pickupSelected;
            data.placardLocationKey = this.placardSelected;
            data.placardLocation = this.placardlocations.filter(x => x.key === this.placardLocation)[0].value;
            data.pickupLocation = this.pickuplocations.filter(x => x.key === this.pickupLocation)[0].value;
            data.metalBoxInd = this.metalBoxInd;
            data.additionalLocationDetails = this.additionalLocationDetails;

            data.lockCombination = this.lockCombination;
            request.placardLocation = data;
        } else {
            request.placardLocation = this.sessionData.placardLocation;
        }
        return request;
    }

    public openModel() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
        document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang}/pagenotfound.page`;
    }

    public openSessionTimeOutModel() {
        this.sessionnTimeOut.open();
    }

    public closeSessionTimeOutModal() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang}/pagenotfound.page`;
            this.sessionnTimeOut.close();
        });
    }

    focusInputLock() {
        document.getElementById("lockCombination").focus();
    }

    focusInputPickup() {
        document.getElementById("pickupLocation").focus();
    }

    focusInputPlacard() {
        document.getElementById("placardLocation").focus();
    }

    focusInputAdditional40() {
        document.getElementById("additionalLocationDetails40").focus();
    }

    focusInputAdditional26() {
        document.getElementById("additionalLocationDetails26").focus();
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            this._commonService.url = '/' + RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE;
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    backBrowser() {
        this.subscription = <Subscription>this.location.subscribe(val => {
            this.sessionData.backBrowserPage = 'Location';
        });
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com', this._translateData.transform('upplm.breadcrumb.home')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com/upplm/dashboard',
            `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`));
        this.breadCrumbItems.push(new BreadcrumbItem('', this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle')));
    }
}
